import { actions } from './filters.actions'
import { getters } from './filters.getters'
import { state } from './filters.state'
import { mutations } from './filters.mutations'

export default { actions, getters, state, mutations, namespaced: true }
